import { get, isString, size, split } from './lodash';

/**
 * 是否是图片文件扩展名
 *
 * @param ext
 */
export const isImageExt = (ext: string) => {
    return /^(png|jpg|jpeg|gif)$/i.test(ext);
};

/**
 * 是否是office文件扩展名
 *
 * @param ext
 */
export const isOfficeExt = (ext: string) => {
    return /^(doc|docx|ppt|pptx|xls|xlsx|wps|ofd)$/i.test(ext);
};

/**
 * 解析文件名称
 *
 * @param fileName
 */
export const parseFileName = (fileName: any): [string, string] => {
    if (!isString(fileName)) {
        return ['', ''];
    }
    const arr = split(fileName, '.');
    if (size(arr) === 1) {
        return [fileName, ''];
    }
    const ext = arr.pop() || '';
    const name = arr.join('.');
    return [name, ext];
};

/**
 * 图片链接
 *
 * @param fileObj
 */
export const getPublicImageUrl = (fileObj: any): string => {
    return get(fileObj, 'url', '');
};
